import { Button, Col, Form, InputGroup, Offcanvas, Row } from "react-bootstrap";
import { CiSquarePlus } from "react-icons/ci";
import { GoTrash } from "react-icons/go";

function ExpertiseSection({
  show,
  hide,
  index,
  setIndex,
  sectionData,
  setSectionData,
  setExpertise,
  mode,
  setMode,
}) {
  const handleSubmit = () => {
    if (mode === "add") {
      setExpertise((prev) => [...prev, sectionData]);
    } else {
      setExpertise((prev) =>
        prev.map((item, i) => (i === index ? sectionData : item)),
      );
    }
    hide();
    setIndex(null);
    setMode("");
    setSectionData("");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSectionData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const addPoint = () => {
    setSectionData((prev) => ({
      ...prev,
      points: [...prev.points, ""],
    }));
  };

  const updatePoint = (index, value) => {
    setSectionData((prev) => {
      const updated = [...prev.points];
      updated[index] = value;

      return { ...prev, points: updated };
    });
  };

  const removePoint = (index) => {
    setSectionData((prev) => ({
      ...prev,
      points: prev.points.filter((_, i) => i !== index),
    }));
  };

  const addHighlight = () => {
    setSectionData((prev) => ({
      ...prev,
      highlights: [...prev.highlights, ""],
    }));
  };

  const updateHighlight = (index, value) => {
    setSectionData((prev) => {
      const updated = [...prev.highlights];
      updated[index] = value;

      return { ...prev, highlights: updated };
    });
  };

  const removeHighlight = (index) => {
    setSectionData((prev) => ({
      ...prev,
      highlights: prev.highlights.filter((_, i) => i !== index),
    }));
  };

  return (
    <Offcanvas show={show} onHide={hide} placement="end" style={{ width: 600 }}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          {mode === "add" ? "Add New Expertise" : `Expertise ${index + 1}`}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Row>
          <Col md={12}>
            <Form.Group className="mb-2">
              <Form.Label>Title</Form.Label>
              <Form.Control
                placeholder="Enter Title"
                name="title"
                value={sectionData?.title}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
          <Col md={12}>
            <Form.Group className="mb-2">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Enter Description"
                name="description"
                value={sectionData?.description}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
          <Col md={12}>
            <div className="hstack gap-2 mb-2">
              <Form.Label className="text-muted m-0">Add points</Form.Label>
              <CiSquarePlus
                title="Add More"
                onClick={addPoint}
                className="text-success CP"
              />
            </div>
            {(sectionData?.points || [])?.map((point, index) => (
              <InputGroup key={index} className="mb-2">
                <Form.Control
                  placeholder="Enter Point"
                  value={point}
                  onChange={(e) => updatePoint(index, e.target.value)}
                />
                <InputGroup.Text>
                  <GoTrash
                    style={{ fontSize: 15 }}
                    className="text-danger CP"
                    title="Delete"
                    onClick={(e) => removePoint(index)}
                  />
                </InputGroup.Text>
              </InputGroup>
            ))}
          </Col>
          <Col md={12}>
            <Form.Group className="mb-2">
              <div className="hstack gap-2">
                <Form.Label>Highlights</Form.Label>
                <CiSquarePlus
                  title="Add More"
                  onClick={addHighlight}
                  className="mb-1 text-success CP"
                />
              </div>
              {(sectionData?.highlights || [])?.map((highlight, index) => (
                <InputGroup key={index} className="mb-2">
                  <Form.Control
                    placeholder="Enter Highlight"
                    value={highlight}
                    onChange={(e) => updateHighlight(index, e.target.value)}
                  />
                  <InputGroup.Text>
                    <GoTrash
                      style={{ fontSize: 15 }}
                      className="text-danger CP"
                      title="Delete"
                      onClick={(e) => removeHighlight(index)}
                    />
                  </InputGroup.Text>
                </InputGroup>
              ))}
            </Form.Group>
          </Col>
          <div className="d-flex justify-content-end gap-2 mt-3">
            <Button onClick={handleSubmit}>
              {mode === "add" ? "Add New" : "Update"}
            </Button>
          </div>
        </Row>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default ExpertiseSection;
